import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default function EmergencyResourcesUTMStudent() {
  return (
    <div>
      <Row>
        <Col xs={10} xsOffset={1}>
          <h2 className="text-center no-bold txt-dkblue">
            Urgent & Emergency Resources
          </h2>
          <p>
            In urgent situations where there’s concerns about anyone's safety, a more
            immediate connection or referral is required even when the person you are
            concerned about is unwilling to access these resources themselves. As soon
            as you can, inform someone who is in a position to act. For situations that
            include harm to self or others, contact the Emergency Situations resources.
            For general, time-sensitive resources, contact one of the Urgent Situations
            resources.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={10} xsOffset={1}>
          <Col xs={12} sm={6}>
            <div className="situation-grid-container">
              <div className="grid-item-heading">Emergency Situations</div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Emergency Services</strong>
                  <br />
                  <a href="tel:911">911</a>
                  <br />
                  24/7
                  <br />
                  Various, Ontario
                  <br />
                  <a href="https://crtc.gc.ca/eng/phone/911" rel="noopener noreferrer" target="_blank">
                    crtc.gc.ca/eng/phone/911
                  </a>
                </div>
                For life-threatening emergencies or incidents occurring in the
                moment where you need police, fire, or ambulance. If responding
                on campus also contact Campus Police to ensure prompt service.
              </div>
              <div className="grid-item ">
                <div className="grid-item-info">
                  <strong>Campus Police</strong>
                  <br />
                  <a href="tel:905 828 5200">905-828-5200</a> (general inquiries)
                  <br />
                  <a href="tel:905 569 4333">905-569-4333</a> (emergencies)
                  <br />
                  24/7
                  <br />
                  DV 3116
                  <br />
                  <a href="https://utm.utoronto.ca/campus-police" rel="noopener noreferrer" target="_blank">
                    www.utm.utoronto.ca/campus-police
                  </a>
                </div>
                Dedicated to creating and maintaining a safe and secure environment for students, staff, faculty and visitors.
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="situation-grid-container">
              <div className="grid-item-heading">Urgent Situations</div>

              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Health & Counselling Centre</strong>
                  <br />
                  <a href="tel:905 828 5255">905 828 5255</a>
                  <br />
                  Business Hours
                  <br />
		  DV 1152
                  <br />
                  <a href="https://www.utm.utoronto.ca/health" rel="noopener noreferrer" target="_blank">
                    www.utm.utoronto.ca/health
                  </a>
                </div>
                HCC provides medical services, physical and mental health services and peer to peer health education through an interdisciplinary team of health professionals. The HCC also has a dedicated student wellness space, the Wellness Den, that features daily, drop-in wellness activities to support learning and success. Drop by the Student Services Hub (DV 2207) to build your wellness routine.
              </div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Immediate On-Campus Supervisor</strong>
                  <br />
                  <span>Name: ___________________</span>
                  <br />
                  <span>Contact: __________________</span>
                </div>
                <span>
                  Whether a referral is made or not - if you are supporting
                  someone as a result of your role as a student leader, staff or
                  faculty member, you should inform your supervisor and/ or the
                  appropriate contact within your unit.
                </span>
              </div>
            </div>
          </Col>
        </Col>
      </Row>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/IARReference/EmergencyResources/EmergencyResourcesUTMStudent.js